
import { COOKIE_DURATION, cookieOpts } from '@/utils/cookieOptions'

export default {
  name: 'InformationMessage',
  props: {
    marginBottom: Boolean,
  },
  data() {
    return {
      dismissed: false,
    }
  },
  computed: {
    isAlreadyDismissed() {
      const dismissedAt = this.$nuxtCookies.get('dismiss_message')
      if (!dismissedAt) return false

      const message = this.$store.state.message
      if (!message || !message.updated_at) return false

      // Si le message a été mis à jour après le dismiss, on le réaffiche
      return new Date(dismissedAt) >= new Date(message.updated_at)
    },
  },
  methods: {
    dismissAlertMessage() {
      const message = this.$store.state.message
      const dismissValue = message?.updated_at || new Date().toISOString()

      this.$nuxtCookies.set('dismiss_message', dismissValue, cookieOpts(COOKIE_DURATION.YEAR))

      this.dismissed = true
    },
  },
}
